/*
 * AppVerifyStepOne Messages
 *
 * This contains all the text for the AppVerifyStepOne component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.AppVerifyStepOne";

export default defineMessages(scope, {
  header: "This is the AppVerifyStepOne component!",
  listItem1:
    "Launch Google Authenticator (Authy and Microsoft Authenticator also supported).",
  listItem2:
    "Tap the “+” icon then select scan barcode. (Select “other” if using Microsoft Authenticator.)",
  cantScanLabel: "Can’t scan?",
  nextButtonLabel: "Next",
  cancelButtonLabel: "Cancel",
  loadingMessage: "loading...",
  qrCode: "QR Code",
});
